/**
 * The container's expenses at the foot of its edit form - to look at only.
 * They are added and deleted in the Expenses window, where the box they are
 * paid from is picked.
 */

import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import SuiTypography from "components/SuiTypography";
import { Section } from "layouts/accounting/Fields";
import { api, problemOf } from "layouts/accounting/api";
import ExpensesTable from "./ExpensesTable";

function ContainerExpensesView({ containerId }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!containerId) return;
    setRows(null);
    setError("");
    api
      .get("/vouchers", { type: "payment", container_id: containerId })
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((e) => setError(problemOf(e, "Could not load the expenses")));
  }, [containerId]);

  return (
    <Section title="Container expenses · مصاريف الكونتينر">
      {error ? (
        <SuiTypography variant="button" color="error">
          {error}
        </SuiTypography>
      ) : (
        <ExpensesTable rows={rows} />
      )}
    </Section>
  );
}

ContainerExpensesView.propTypes = {
  containerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ContainerExpensesView;
